import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-medeildownload',
  templateUrl: './medeildownload.component.html',
  styleUrls: ['./medeildownload.component.scss']
})
export class MedeildownloadComponent {
  indianEditionClicked: boolean = false;
  internationalEditionClicked: boolean = false;
  constructor(@Inject(PLATFORM_ID) private platformId: Object,
  private title: Title,
  private meta: Meta,){
  this.setSeoMeta()
  }

  toggleIndianEdition() {
    this.indianEditionClicked = true;
    this.internationalEditionClicked = false;
  }

  toggleInternationalEdition() {
    this.internationalEditionClicked = true;
    this.indianEditionClicked = false;
  }

  setSeoMeta() {
    const supportedLanguages = ['en', 'fr', 'es', 'pt'];
    let finalUrl = '';
    let lang = 'en';

    if (isPlatformBrowser(this.platformId)) {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const parts = path.split('/');

      if (supportedLanguages.includes(parts[1])) {
        lang = parts[1];
      }

      const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, '');
      finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;
    }

    // SEO content based on specific page
    const seoTexts: any = {
      en: {
        title: 'Download Medeil – Pharmacy & Healthcare Software Tools',
        description:
          'Download MEDEIL’s pharmacy and hospital software to streamline workflows, ensure compliance, and improve patient care with smart management tools.',
        keywords:
          'Download pharmacy software, Medeil software download, medical software, healthcare software, clinic management tools, hospital software free trial'
      },
      es: {
        title: 'Descargar Medeil: software para gestión de farmacias y clínicas',
        description:
          'Descargue el software de gestión Medeil para farmacias y hospitales. Optimice la atención al paciente y la administración médica desde hoy mismo.',
        keywords:
          'descargar software de farmacia, Medeil, gestión clínica, software hospitalario, herramientas médicas, software sanitario'
      },
      fr: {
        title: 'Télécharger Medeil : logiciel de gestion pour pharmacies et hôpitaux',
        description:
          'Téléchargez Medeil, le logiciel de gestion médicale pour cliniques et pharmacies. Améliorez vos opérations de santé avec une solution professionnelle.',
        keywords:
          'téléchargement logiciel pharmacie, Medeil, gestion médicale, logiciel santé, hôpital, clinique, essai gratuit'
      },
      pt: {
        title: 'Baixar Medeil: software de gestão para farmácias e clínicas',
        description:
          'Baixe o Medeil agora mesmo e otimize a gestão da sua farmácia ou clínica com uma solução confiável e eficiente para saúde.',
        keywords:
          'baixar software farmácia, Medeil, software médico, gestão clínica, hospitalar, ferramentas de saúde, aplicativo de saúde'
      }
    };

    const localizedSeo = seoTexts[lang] || seoTexts['en'];

    const seoData = {
      ...localizedSeo,
      image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
      url: finalUrl
    };

    this.title.setTitle(seoData.title);

    const metaTags = [
      { name: 'description', content: seoData.description },
      { name: 'keywords', content: seoData.keywords },
      { property: 'og:title', content: seoData.title },
      { property: 'og:description', content: seoData.description },
      { property: 'og:url', content: seoData.url },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: seoData.image }
    ];

    metaTags.forEach(tag => this.meta.updateTag(tag));
  }

}
